import { rankingData } from '@/mocks/home';

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-50" style={{ scrollMarginTop: '4rem' }}>
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-foreground-950 mb-2">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-500">全网吃瓜热搜实时排行榜</p>
        </div>
        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingData.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 ${
                i < rankingData.length - 1 ? 'border-b border-background-100' : ''
              } hover:bg-background-100/50 transition-colors cursor-pointer`}
            >
              <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-950 font-medium truncate">{item.title}</p>
              </div>
              <div className="flex-shrink-0 flex items-center gap-2">
                <span className="text-xs whitespace-nowrap">{item.heat}</span>
                <span className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
                  item.tag === '爆' ? 'bg-primary-100 text-primary-700' :
                  item.tag === '热' ? 'bg-accent-100 text-accent-700' :
                  'bg-secondary-100 text-secondary-700'
                }`}>{item.tag}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}